import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  closeButton: css`
    width: ${theme.spacing(6)}px;
    height: ${theme.spacing(6)}px;
    font-size: ${theme.spacing(6)}px;
    color: ${theme.go.schemes.colors.system.BgMain};
    background: rgba(0, 0, 0, 0.5);
    margin-left: auto;
    margin-bottom: ${theme.spacing(1)}px;
  `,
}

export const panelClasses = {
  paper: css`
    background: transparent;
    padding: ${theme.spacing(1)}px;
  `,
}

export const postcardClasses = {
  root: css`
    position: static;
    box-shadow: none;
    width: auto;
  `,
  postcard: css`
    height: min(100vh, 100vw);
  `,
}
